import { z } from '@/utils/zod'

export const OAuthBaseAuthProviderSchema = z.object({
    clientId: z.string().min(1),
    clientSecret: z.string().min(1),
    scopes: z.array(z.string()),
    syncOnLogin: z.boolean(),
})
